export default __webpack_public_path__ + "static/media/bad.03901445.png";